module.exports = __webpack_public_path__ + "img/shopping-basket-line.3b62c0a1.svg";